import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type JumpcloudConnectorConfig = typeof JumpcloudConnector._.Config;
export type JumpcloudConnectorNamedConfig = typeof JumpcloudConnector._.NamedConfig;

export enum JumpcloudRegion {
  EU = 'eu',
  US = 'us',
}

export const JumpcloudConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Jumpcloud,
  logoPath: 'images/jumpcloud-logo.svg',
  categories: [IntegrationConnectorCategory.Identity, IntegrationConnectorCategory.Endpoint],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ServiceAccountOauth,
      configSchema: z.object({
        region: z.enum(JumpcloudRegion),
        organizationId: z.string().trim(),
        clientId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
    IntegrationAuth.manual({
      deprecated: true,
      name: Integration_Auth_Names_Enum.ApiKey,
      configSchema: z.object({
        region: z.enum(JumpcloudRegion).default(JumpcloudRegion.US),
        organizationId: z.string().trim().optional(),
      }),
      encryptedConfigSchema: z.object({
        apiKey: z.string().trim().min(1),
      }),
    }),
  ]),
});
